export const LEADS_RESET_STATE = 'LEADS_RESET_STATE';
export const LEADS_CURRENT_ITEM = 'LEADS_CURRENT_ITEM';

export const LEADS_REQUEST_LOADING = 'LEADS_REQUEST_LOADING';
export const LEADS_REQUEST_SUCCESS = 'LEADS_REQUEST_SUCCESS';
export const LEADS_REQUEST_FAILED = 'LEADS_REQUEST_FAILED';

export const LEADS_CURRENT_ACTION = 'LEADS_CURRENT_ACTION';
export const LEADS_RESET_ACTION = 'LEADS_RESET_ACTION';